<template>
<modal name="joblist-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>


  <div class="setting">
    <div class="setting-item" style="text-align:center;">
      <div style="text-align: center;">
          <div style="display: inline-block;min-width: 100%;text-align:center;">
            <p style="font-size: 140%;"> 
              <img src="/static/renew_img/mv_title.png" alt="あなたのための求人を持ってきたメェ〜！" style="width:90%" >
            </p>
          </div>
          <p style="padding: 15px 0; font-weight: bold;">お仕事を探すお手伝いをします！<br>気になる求人をクリック！</p>
          <div style="">
              <div style="display: flex; justify-content: flex-end;">
                  <img src="/static/renew_img/logo_box.jpeg" alt="求人ボックス" style="width:60%">
              </div>
              <!--1つの求人ここから-->
              <a v-for="(item, index) in job_list" @click="clickJob()"
              :key="index" :href="item.url" target="_blank"><!--url-->
                  <div style="background: #EFF8F8; padding: 20px; margin-top: 20px;">
                      <div style="display: flex; align-items: center;">
                          <p style="background: #0F9934; color: #fff; border-radius: 50px; padding: 2px 10px; margin-right: 5px; font-size: 0.5rem;flex-wrap: wrap;">{{item.jt}}</p><!--jt-->
                          <p style="flex-wrap: wrap;">{{item.st}}</p><!--st-->
                      </div>
                      <h4 style="color: #004D40; padding: 5px 0; line-height: 1.4; font-size: 110%; text-align: left;">{{item.title}}</h4><!--title-->
                      <p style="opacity: 0.5; text-align: left;">{{item.company}}／{{item.area}}</p><!--area-->
                      <p style="opacity: 0.5; width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: left;">{{item.snippet}}</p><!--snippet-->
                      <button type="button" class="el-button el-button--success" id="send-mynabi-pdf" style="background-color: #E3165C; border-color: #E3165C; font-size: 120%; margin: 15px 0px 0px;"><!----><!----><span>お仕事を詳しく見てみる</span></button>
                  </div>
              </a>
          </div>
      </div>
    </div>
  </div>


</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      keyword: '',
      area: '',
      previewHtml: '',
      permissionType: 1,
      isSended:false,
      isSendedJigen:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true,
      job_list:[]
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openJoblistDialog: function (id, html, keyword, address) {
      console.error('Joblist openDialog')
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.clearLocalStorageConfirmVisible = false
      this.keyword = keyword
      this.area = address

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'joblist_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })

      formData.append('keyword', keyword)
      formData.append('area', address)
      formData.append('joblist_numb', 10)
      if (this.formatid == "rerekisho_part_time" || 
        this.formatid == "rirekisho_part_time2") {
        formData.append('jt', '2')
      } else if (this.formatid == "rirekisho_job_new" ||  
        this.formatid == "rirekisho_job_new_single" ||  
        this.formatid == "internship") {
        formData.append('jt', '6')
      } else {
        formData.append('jt', '0')
      }

      this.$axios
        .post(this.$varuna.endPoints.getKakakuJobList, formData, {timeout: 60000})
        .then(function (response) {
          app.$modal.show('joblist-dialog')
          app.job_list = response.data.results
          console.error(app.job_list)
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `あなたにピッタリの求人リストを取得しました`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '求人リスト取得に失敗しました',
            type: 'error'
          })
        }).finally(function () {
        })

      
    },
    closeDialog: function () {
      this.$modal.hide('joblist-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendJoblistConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'joblist_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.joblistPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたに電話・メールでご連絡することがあります！`,
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    clickJob: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('keyword', this.keyword)
      formData.append('area', this.area)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      formData.append('app_flag', '')

      const app = this
      this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, {timeout: 60000})
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-joblist-consult', this.sendJoblistConsult)
    this.$eventHub.$on('send-joblist-scout', this.sendJoblistScout)
    this.$eventHub.$on('open-joblist-dialog', this.openJoblistDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-joblist-consult', this.sendJoblistConsult)
    this.$eventHub.$off('send-joblist-scout', this.sendJoblistScout)
    this.$eventHub.$off('open-joblist-dialog', this.openJoblistDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
